import { AlpineComponent } from 'alpinejs';

const Table = (): AlpineComponent => ({
  hiddenRows: 0,
  isExpanded: false,
  visibleRows: [],

  hidesSelectedTableRows(hiddenRows, tableChildren) {
    tableChildren.forEach((child, index) => {
      if (index >= hiddenRows) {
        child.classList.add('hide');
      }
    });
  },

  toggleRows() {
    const tableElement = this.$root;
    const tableChildElements = tableElement.querySelectorAll('tbody tr');
    const ctaElement = this.$root.querySelector('.table__cta');
    const ctaLabel = ctaElement.querySelector('div.table__cta span.typo-button');
    const less = ctaLabel.getAttribute('data-label-close');
    const more = ctaLabel.getAttribute('data-label-expand');

    this.isExpanded = !this.isExpanded;

    if (this.visibleRows.length === 0) {
      this.visibleRows = Array.from(tableChildElements).filter(child => child.classList.contains('hide'));
    }

    this.visibleRows.forEach(row => {
      row.classList.toggle('hide');
    });

    ctaElement.classList.toggle('hide');
    ctaLabel.innerText = this.isExpanded ? less : more;
  },

  init() {
    const tableElement = this.$root;

    if (!tableElement) return;

    this.hiddenRows = parseInt(tableElement.getAttribute('data-hide-rows'), 10);
    const tableChildElements = tableElement.querySelectorAll('tbody tr');

    this.hidesSelectedTableRows(this.hiddenRows, tableChildElements);
  }
});

export default Table;